import { render, staticRenderFns } from "./DotDrop.vue?vue&type=template&id=deb5b1f0&scoped=true&"
import script from "./DotDrop.vue?vue&type=script&lang=js&"
export * from "./DotDrop.vue?vue&type=script&lang=js&"
import style0 from "./DotDrop.vue?vue&type=style&index=0&id=deb5b1f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deb5b1f0",
  null
  
)

export default component.exports